import { render } from "./monthesReportPage.vue?vue&type=template&id=0cb5da68"
import script from "./monthesReportPage.vue?vue&type=script&lang=js"
export * from "./monthesReportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__